import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StateComponent } from '../state-component.interface';
import { Usdm2Service } from '../../../../services/ai/usdm2.service';
import { Subscription } from 'rxjs';

type objectives = {
  name: string;
  objective_level_uid: string;
}

type objectivesResponse = {
  all_objectives: objectives[];
}

@Component({
  selector: 'app-objectives',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './objectives.component.html',
  styleUrls: ['./objectives.component.css'],
})
export class ObjectivesComponent implements StateComponent, OnInit, OnDestroy {
  stateName = 'Objectives';
  primaryObjectives: string[] = [];
  secondaryObjectives: string[] = [];
  data: objectivesResponse | null = null;

  constructor(private usdm: Usdm2Service) {}

  private usdmSub: Subscription | null = null;

  ngOnInit(): void {
    this.usdmSub = this.usdm.contentUpdate$.subscribe((item) => {
      if (item && item.type === 'FinishResponse' && this.usdm.currentState() == this.stateName) {
        this.data = (item.result as objectivesResponse);
        this.extractObjectives(this.data);
        this.usdm.signalStateCompletion(this.stateName);
      }
    });
  }

  ngOnDestroy(): void {
    this.usdmSub?.unsubscribe();
    this.usdmSub = null;
  }

  extractObjectives(data: objectivesResponse): void {
    if (!data || !data.all_objectives || !Array.isArray(data.all_objectives)) {
      return;
    }
    this.primaryObjectives = [];
    this.secondaryObjectives = [];

    for (const obj of data.all_objectives) {
      const uid = (obj?.objective_level_uid ?? '').toString().toLowerCase();
      const name = obj?.name ?? '';
      if (!name) continue;
      if (uid.endsWith('prim')) {
        this.primaryObjectives.push(name);
      } else {
        this.secondaryObjectives.push(name);
      }
    }
  }
}
